import * as tslib_1 from "tslib";
import { SentimentColors } from "../../../constants";
import cx from 'classnames';
import React, { PureComponent } from 'react';
import { getItem, getPercent } from '../../../utils/card-value';
import { isFiniteNumber } from '../../../utils/checks';
import { getSentimentColor } from '../utils';
import Styles from "./ScaleViewChart.css";
var maxIndex = SentimentColors.length - 1;

var ScaleViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(ScaleViewChart, _super);

  function ScaleViewChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ScaleViewChart.prototype.render = function () {
    var _a = this.props,
        entityType = _a.entityType,
        min = _a.min,
        max = _a.max,
        value = _a.value,
        getLabel = _a.getLabel;
    var color = getItem(SentimentColors, value, min, max);
    return React.createElement("div", {
      className: Styles.scaleViewChart
    }, React.createElement("div", {
      className: Styles.title
    }, entityType), React.createElement("div", {
      className: cx(Styles.body, getSentimentColor(color, Styles))
    }, SentimentColors.map(function (colorName) {
      return React.createElement("div", {
        key: colorName,
        className: cx(Styles.item, getSentimentColor(colorName, Styles))
      });
    }), isFiniteNumber(value) && React.createElement("div", {
      className: Styles.triangle,
      style: {
        left: getPercent(value, min, max) * 100 + "%"
      }
    })), React.createElement("div", {
      className: Styles.labels
    }, SentimentColors.map(function (colorName, index) {
      return React.createElement("div", {
        key: colorName,
        className: cx(Styles.label, colorName === color && Styles.active)
      }, getLabel(index === 0 ? min : index === maxIndex ? max : value));
    })));
  };

  return ScaleViewChart;
}(PureComponent);

export default ScaleViewChart;